import { Dispatch } from 'redux';
import { InstrumentoEdicaoResponse } from 'common/genericTypes';
import { axiosInstance, request, requestConfig } from './base';

export const GETInstrumentosEdicao = async (
  dispatch: Dispatch,
  filter: any,
  stackRequest: boolean = false
): Promise<Array<InstrumentoEdicaoResponse>> => {
  return await request(
    () =>
      axiosInstance.get<Array<InstrumentoEdicaoResponse>>(
        `${requestConfig.api}api/v1/instrumento-edicao`,
        { params: filter }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
